import { render, staticRenderFns } from "./PopoverElement.vue?vue&type=template&id=92d7997e&scoped=true&"
import script from "./PopoverElement.vue?vue&type=script&lang=js&"
export * from "./PopoverElement.vue?vue&type=script&lang=js&"
import style0 from "./PopoverElement.vue?vue&type=style&index=0&id=92d7997e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d7997e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92d7997e')) {
      api.createRecord('92d7997e', component.options)
    } else {
      api.reload('92d7997e', component.options)
    }
    module.hot.accept("./PopoverElement.vue?vue&type=template&id=92d7997e&scoped=true&", function () {
      api.rerender('92d7997e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/PopoverElement.vue"
export default component.exports